<template>
  <div class="aside__block -min-width-">
    <Head></Head>
    <Form></Form>
  </div>
</template>

<script>
import Head from './components/Head';
import Form from './components/Form';

import { mapActions } from 'vuex';

export default {
  components: { Head, Form },
  methods: {
    ...mapActions('usersGroups', ['setAsideMeta', 'setAsideData'])
  }
};
</script>
